
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accounts/sync-google-calendar",
      function () {
        return require("private-next-pages/accounts/sync-google-calendar/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accounts/sync-google-calendar"])
      });
    }
  